import { ProgramNames } from '@/models/Program';

import { CountrySelect } from './ReviewerAssignmentSelects/CountrySelect';
import { ProgramSelect } from './ReviewerAssignmentSelects/ProgramSelect';

export function InternationalAssignmentFields({
  selectedPrograms,
  onProgramsChange,
  selectedCountries,
  onCountriesChange,
}: {
  selectedPrograms: ProgramNames[];
  onProgramsChange: (programIds: ProgramNames[]) => void;
  selectedCountries: number[];
  onCountriesChange: (countryIds: number[]) => void;
}) {
  return (
    <>
      <CountrySelect selectedCountries={selectedCountries} onCountriesChange={onCountriesChange} />

      <ProgramSelect selectedPrograms={selectedPrograms} onProgramsChange={onProgramsChange} />
    </>
  );
}
